import React from 'react';
import { useTranslation } from 'react-i18next';
import { card, h2, sub, pill, RGB } from './extUi';

const mapLabel = (n) => { const s = String(n || '').replace(/^(de_|cs_)/, ''); return s.charAt(0).toUpperCase() + s.slice(1); };
const TEAM_RGB = { team1: '96,165,250', team2: '251,146,60' };

// The submitted veto of an external match (match.veto): play order with sides, then the full action log.
export default function ExtVetoSummary({ veto }) {
  const { t } = useTranslation();
  if (!veto) return null;
  const name = (k) => (veto.teams[k] ? veto.teams[k].name : '');
  const teamSpan = (k) => <span style={{ color: `rgb(${TEAM_RGB[k]})`, fontWeight: 700 }}>{name(k)}</span>;
  return (
    <div style={card}>
      <h2 style={h2}>{t('ext.vetoTitle', 'Veto')} <span style={{ ...pill(RGB.cyan), marginLeft: '0.4rem' }}>{veto.format === 'faceit' ? 'FACEIT' : 'VRS'} · BO{veto.best_of}</span></h2>
      <p style={sub}>{t('ext.vetoSubmitted', 'Submitted {{when}} from the veto link.', { when: new Date(veto.submitted_at).toLocaleString() })}</p>
      <div style={{ display: 'grid', gap: '0.4rem', marginBottom: '0.9rem' }}>
        {veto.maps.map(m => (
          <div key={m.order} style={{ display: 'flex', gap: '0.7rem', alignItems: 'center', flexWrap: 'wrap', padding: '0.5rem 0.7rem', border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-md)' }}>
            <span style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: '0.75rem', color: 'var(--text-muted)' }}>{t('ext.vetoMapN', 'Map {{n}}', { n: m.order })}</span>
            <span style={{ fontWeight: 800, color: 'var(--text-primary)', minWidth: 90 }}>{mapLabel(m.map)}</span>
            <span style={{ fontSize: '0.78rem', color: 'var(--text-secondary)' }}>
              {m.picked_by === 'decider' ? t('ext.vetoDecider', 'Decider') : <>{t('ext.vetoPickedBy', 'Picked by')} {teamSpan(m.picked_by)}</>}
            </span>
            <span style={{ marginLeft: 'auto', fontSize: '0.78rem', color: 'var(--text-secondary)' }}>
              {m.starting_sides
                ? <>{teamSpan('team1')} {m.starting_sides.team1.toUpperCase()} · {teamSpan('team2')} {m.starting_sides.team2.toUpperCase()}</>
                : t('ext.vetoKnife', 'Knife for sides')}
            </span>
          </div>
        ))}
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem' }}>
        {veto.actions.map(a => (
          <span key={a.order} style={{ ...pill(a.team ? TEAM_RGB[a.team] : RGB.amber), fontWeight: 600 }}>
            {a.order}. {a.team ? name(a.team) : t('ext.vetoDecider', 'Decider')}{' '}
            {a.action === 'ban' && t('ext.vetoActBan', 'ban {{map}}', { map: mapLabel(a.map) })}
            {a.action === 'pick' && t('ext.vetoActPick', 'pick {{map}}', { map: mapLabel(a.map) })}
            {a.action === 'side' && t('ext.vetoActSide', '{{side}} on {{map}}', { side: a.side.toUpperCase(), map: mapLabel(a.map) })}
            {a.action === 'decider' && mapLabel(a.map)}
          </span>
        ))}
      </div>
    </div>
  );
}
